var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoRwalpha(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4434_136)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4434_136",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 52,
    height: 52
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 0H0V52H52V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4434_136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 52C40.3594 52 52 40.3594 52 26C52 11.6406 40.3594 0 26 0C11.6406 0 0 11.6406 0 26C0 40.3594 11.6406 52 26 52Z",
    fill: "#2C5DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4279 20.1565H17.8573C17.5413 20.1565 17.2852 20.4126 17.2852 20.7286V25.3044C17.2852 25.6204 17.5413 25.8765 17.8573 25.8765H22.4279C22.7439 25.8765 23 25.6204 23 25.3044V20.7286C23 20.4126 22.7439 20.1565 22.4279 20.1565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7131 13.2925H12.1424C11.8265 13.2925 11.5703 13.5486 11.5703 13.8646V18.4404C11.5703 18.7563 11.8265 19.0125 12.1424 19.0125H16.7131C17.029 19.0125 17.2852 18.7563 17.2852 18.4404V13.8646C17.2852 13.5486 17.029 13.2925 16.7131 13.2925Z",
    fill: "#FF922C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8797 27.0847L17.8573 27.0847C17.5413 27.0847 17.2852 27.3408 17.2852 27.6568V38.0314C17.2852 38.3473 17.5413 38.6035 17.8573 38.6035H22.4279C22.7439 38.6035 23 38.3473 23 38.0314V32.7405H28.953L32.7309 38.1832C32.9447 38.4913 33.2959 38.675 33.6709 38.675H39.1223C39.5841 38.675 39.8556 38.156 39.5923 37.7766L35.5011 31.8825H35.3367C35.6064 31.7622 35.8666 31.6292 36.1174 31.4836C37.5604 30.6457 38.6399 29.5046 39.356 28.0604C40.0722 26.6161 40.4303 24.9789 40.4303 23.1488C40.4303 21.3187 40.0668 19.6594 39.3398 18.171C38.6128 16.6827 37.5333 15.4975 36.1012 14.6155C34.6689 13.7335 32.9172 13.2925 30.8462 13.2925H23.6436C23.3276 13.2925 23.0714 13.5486 23.0714 13.8646V18.3761C23.0714 18.6921 23.3276 18.9482 23.6436 18.9482H30.8797C32.2677 18.9482 33.3363 19.301 34.0854 20.0066C34.8343 20.7123 35.2088 21.7266 35.2088 23.0496C35.2089 24.3725 34.8345 25.3758 34.0854 26.0594C33.3363 26.7429 32.2677 27.0847 30.8797 27.0847Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4434_136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRwalpha);
export default __webpack_public_path__ + "static/media/logo-rwalpha.a3f64fc52fa7454e944e5fdd6739ce0c.svg";
export { ForwardRef as ReactComponent };